import React from "react";
import { useQuery } from "react-query";

import Loading from "src/components/Loading";
import { getSection } from "src/hooks/useContentful/getSection";
import { useFetchContent } from "src/hooks/useContentful/useFetchContent";

import contentfulClient from "src/services/contentful";
import useMedia from "use-media";
import Carroussel from "./Carroussel";
import Item from "./Item";
import { ContainerListButton, InnerContainer } from "./styles";

function Steps() {
  const isMd = useMedia({ minWidth: 1050 });
  const content = useFetchContent();
  const section = getSection({
    sectionName: "landingStepperSection",
    data: content.data,
  });

  const { data, isLoading } = useQuery(
    "getSteps",
    () =>
      Promise.all(
        section.steps.map(
          async (step) => await contentfulClient.getEntry(step.sys.id)
        )
      ),
    {
      enabled: content.data && !content.isLoading,
    }
  );

  if (content.isLoading || !content.data || isLoading || !data)
    return <Loading />;

  const list = data.map(({ fields }, index) => (
    <Item item={fields} key={index} />
  ));

  return (
    <InnerContainer>
      <ContainerListButton>
        {isMd ? (
          data.map(({ fields }, index) => (
            <>
              <div key={index}>
                <Item item={fields} />
              </div>
            </>
          ))
        ) : (
          <Carroussel list={list} />
        )}
      </ContainerListButton>
    </InnerContainer>
  );
}

export default Steps;
